export default {
    // URL: 'https://localhost:7096',
    // URL: 'https://localhost:32770',
    URL: 'https://kd2025api.devaidsoft.net',
    APIURL: 'https://kd2025api.devaidsoft.net',
    // ChannelKey: "channel-key-6a563fcd-16d4-4c02-a13b-389b7c694b54", // test
    ChannelKey: "channel-key-76325ecb-85f7-4035-8958-206972034a5a", // live
    ROUTES: {
        register: '/',
    },
    HEADERS: {
        AppID: 'a016878d-e2ff-4ea6-876b-195125445df5',
        AppKey: 'vKahY3N3K1wf1J7GSmZHMIkodEFBAlTuZ6bIBbUSCgjfTHKz1lix877HN9hUF0zO',
    },
};
